// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 654) return "js/654.js";
	if (chunkId === 72) return "js/72.js";
	if (chunkId === 427) return "js/427.js";
	// return url for filenames based on template
	return undefined;
};